module.exports = __webpack_public_path__ + "static/media/light_bulb.bcf85231.png";